import { Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { colorTokens } from '../../app/designTokens';
import { RegisterSectionCard } from './RegisterSectionCard';

const { semantic } = colorTokens;

const DONE_STEP_KEYS = ['next_step_activate', 'next_step_login', 'next_step_invite'];

/** Step 6 — next steps + support info. */
export function LaunchNextStepsCard({ testId = 'register-launch-next-steps' }) {
  const { t } = useTranslation(['onboarding']);

  return (
    <RegisterSectionCard
      title={t('onboarding:register.wizard.next_steps_title')}
      testId={testId}
    >
      <Stack component="ol" spacing={0.75} sx={{ m: 0, pl: 2.5 }}>
        {DONE_STEP_KEYS.map((key) => (
          <Typography
            component="li"
            key={key}
            data-testid={`register-launch-${key.replace(/_/g, '-')}`}
            sx={{ fontSize: 13, color: semantic.text.secondary }}
          >
            {t(`onboarding:register.wizard.${key}`)}
          </Typography>
        ))}
      </Stack>
      <Typography sx={{ fontSize: 12, color: semantic.text.muted, mt: 1.5 }}>
        {t('onboarding:register.wizard.support_info')}
      </Typography>
    </RegisterSectionCard>
  );
}

export default LaunchNextStepsCard;
